import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Pagination,
  Radio,
  Row,
  Table,
} from "antd";
import moment from "moment";

import nutrientsApi from "../../../apis/Nutrients.api";
import promotionApi from "../../../apis/Promotion.api";
import { setLoading } from "../../../redux/store/common/commonDuck";
import ContentHeaderComponent from "../../layout/ContentHeaderComponent";

const ContentListComponent = () => {
  let history = useHistory();
  const dispatch = useDispatch();

  const isLoading = useSelector((state) => state.common.loading);
  const setIsLoading = (value) => dispatch(setLoading(value));

  const [searchOptions, setSearchOptions] = useState({
    content_title: null,
    hashtag: null,
    is_exposure: true,
    exposure_place: null,
    category: null,
    sub_category: null,
  });
  const [orderType, setOrderType] = useState("created_at");
  const [orderBy, setOrderBy] = useState("desc");
  const [currentPageNumber, setCurrentPageNumber] = useState(1);
  const [offset, setOffset] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [contentList, setContentList] = useState([]);
  const [totalSize, setTotalSize] = useState(0);
  const [symptomList, setSymptomList] = useState([]);
  const [error, setError] = useState("");

  const exposureItemList = [
    { label: "노출", value: true },
    { label: "미노출", value: false },
  ];
  const exposurePlaceItemList = [
    { label: "상단배너", value: "top_banner" },
    { label: "베스트", value: "best" },
    { label: "일반", value: "common" },
  ];
  const categoryItemList = [
    { label: "비교하기", value: "compare" },
    { label: "영양백과", value: "nutrition_encyclopedia" },
    { label: "연령별", value: "age" },
    { label: "증상별", value: "symptom" },
    { label: "트렌드", value: "trend" },
    { label: "선택기준", value: "selection" },
    { label: "브랜드", value: "brand" },
    { label: "기타", value: "etc" },
  ];
  const targetAgeItems = [
    { label: "0~2세", value: 0 },
    { label: "2~13세", value: 1 },
    { label: "0~13세", value: 2 },
    { label: "청소년", value: 3 },
    { label: "청소년부터 성인까지", value: 4 },
    { label: "성인", value: 5 },
    { label: "전 연령", value: 6 },
    // {label: "성인 여성", value: 7},
    // {label: "성인 남성", value: 8},
    { label: "50세 이상", value: 9 },
    // {label: "50세 이상 남성", value: 10},
    // {label: "50세 이상 여성", value: 11},
    // {label: "임산부", value: 12},
    { label: "기타", value: 99 },
  ];
  const orderPair = {
    created_at: "등록일순",
    updated_at: "수정일순",
    is_exposure: "노출여부순",
    is_best: "베스트순",
  };
  const columns = [
    {
      title: "노출여부",
      // width: 120,
      dataIndex: "is_exposure",
      key: "is_exposure",
      // ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return "노출";
        } else {
          return "미노출";
        }
      },
    },
    {
      title: "상단배너",
      // width: 120,
      dataIndex: "top_banner",
      key: "top_banner",
      // ellipsis: true,
      render: (value) => {
        if (value) {
          return value;
        } else {
          return "-";
        }
      },
    },
    {
      title: "베스트",
      // width: 120,
      dataIndex: "is_best",
      key: "is_best",
      // ellipsis: true,
      // sorter: (a, b) => {},
      render: (value) => {
        if (value) {
          return "o";
        } else {
          return "x";
        }
      },
    },
    {
      title: "카테고리",
      // width: 120,
      dataIndex: "category",
      key: "category",
      // ellipsis: true,
      render: (value) => {
        const findIdx = categoryItemList.findIndex(
          (category) => category.value === value,
        );
        if (findIdx !== -1) {
          return categoryItemList[findIdx].label;
        }
      },
    },
    {
      title: "콘텐츠명",
      // width: 120,
      dataIndex: "head_copy",
      key: "head_copy",
      ellipsis: true,
    },
    {
      title: "등록일",
      // width: 120,
      dataIndex: "created_at",
      key: "created_at",
      // ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        return moment(value).format("YYYY.MM.DD");
      },
    },
    {
      title: "수정일",
      // width: 120,
      dataIndex: "updated_at",
      key: "updated_at",
      // ellipsis: true,
      sorter: (a, b) => {},
      render: (value) => {
        return moment(value).format("YYYY.MM.DD");
      },
    },
  ];

  useEffect(() => {
    getNutrientSearchOption();
    getContentList("initial");
  }, []);

  useEffect(() => {
    getContentList();
  }, [offset, pageSize, orderType, orderBy]);

  const getNutrientSearchOption = async () => {
    setIsLoading(true);
    try {
      const res = await nutrientsApi.readNutrientSearchOption("");
      if (res.code === 200) {
        setSymptomList(res.result.nutrientEffectList);
      } else {
        throw `효능 정보를 가져오기 못했습니다. 다시 시도해주시길 바랍니다.`;
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getNutrientSearchOption read error", error);
      alert(error);
    }
  };

  const getContentList = async (type = "") => {
    setIsLoading(true);
    try {
      let param;
      if (type === "initial") {
        param = {
          content_title: null,
          hashtag: null,
          is_exposure: true,
          exposure_place: null,
          category: null,
          sub_category: null,
          offset: 0,
          pageSize: 10,
          orderType: "created_at",
          orderBy: "desc",
        };
      } else if (type === "search") {
        param = {
          content_title: searchOptions.content_title,
          hashtag: searchOptions.hashtag,
          is_exposure: searchOptions.is_exposure,
          exposure_place:
            searchOptions.exposure_place &&
            searchOptions.exposure_place?.length !== 0
              ? searchOptions.exposure_place.join(",")
              : null,
          category:
            searchOptions.category && searchOptions.category?.length !== 0
              ? searchOptions.category.join(",")
              : null,
          sub_category:
            searchOptions.sub_category &&
            searchOptions.sub_category?.length !== 0
              ? searchOptions.sub_category.join(",")
              : null,
          offset: 0,
          pageSize: 10,
          orderType: orderType,
          orderBy: orderBy,
        };
      } else {
        param = {
          content_title: searchOptions.content_title,
          hashtag: searchOptions.hashtag,
          is_exposure: searchOptions.is_exposure,
          exposure_place:
            searchOptions.exposure_place &&
            searchOptions.exposure_place?.length !== 0
              ? searchOptions.exposure_place.join(",")
              : null,
          category:
            searchOptions.category && searchOptions.category?.length !== 0
              ? searchOptions.category.join(",")
              : null,
          sub_category:
            searchOptions.sub_category &&
            searchOptions.sub_category?.length !== 0
              ? searchOptions.sub_category.join(",")
              : null,
          offset: offset,
          pageSize: pageSize,
          orderType: orderType,
          orderBy: orderBy,
        };
      }
      const res = await promotionApi.readContentList(param);
      if (res.code === 200) {
        setContentList(res.result.contentDTOList);
        setTotalSize(res.result.totalCnt);
      } else {
        alert(
          "콘텐츠 목록을 조회해오지 못하였습니다.\n다시 시도해주시거나 관리자에게 문의해주시길 바랍니다.",
        );
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      setError(error);
      console.log("getContentList read error", error);
    }
  };

  const handleSearchOptionChange = (name, checkedValue, check) => {
    console.log("handleSearchOptionChange", name, checkedValue, check);
    if (name === "is_exposure" && !checkedValue) {
      setSearchOptions({
        ...searchOptions,
        [name]: checkedValue,
        exposure_place: null,
      });
    } else if (name === "sub_category") {
      if (check) {
        let saveValue;
        if (searchOptions.sub_category) {
          saveValue = [...searchOptions.sub_category, checkedValue];
        } else {
          saveValue = [checkedValue];
        }
        setSearchOptions({ ...searchOptions, [name]: saveValue });
      } else {
        let currValue = Array.from(searchOptions.sub_category);
        const findIdx = currValue.findIndex((item) => item === checkedValue);
        if (findIdx !== -1) {
          currValue.splice(findIdx, 1);
        }
        setSearchOptions({ ...searchOptions, [name]: currValue });
      }
    } else {
      setSearchOptions({ ...searchOptions, [name]: checkedValue });
    }
  };

  /**
   * 검색
   */
  const handleSearch = () => {
    setOffset(0);
    setPageSize(10);
    setCurrentPageNumber(1);
    getContentList("search");
  };

  /**
   * 초기화
   */
  const handleInitialBtnClick = () => {
    setSearchOptions({
      content_title: null,
      hashtag: null,
      is_exposure: true,
      exposure_place: null,
      category: null,
      sub_category: null,
    });
    setOffset(0);
    setPageSize(10);
    getContentList("initial");
  };

  const tableOnChange = (pagination, filters, sorter, extra) => {
    if (sorter) {
      //sorting 이벤트가 이루어졌을때
      if (sorter.order) {
        if (sorter.order === "descend") {
          setOrderBy("desc");
        } else if (sorter.order === "ascend") {
          setOrderBy("asc");
        }
        setOrderType(sorter.field);
        //sorting 이벤트 데이터가 초기화 되었을 시 (order 값 초기화)
      } else {
        setOrderType("created_at");
        setOrderBy("desc");
      }
    }
  };

  const handleRowEvent = (record) => {
    return {
      onClick: (_) => {
        // history.push(`/promotion/content/register/${record.id}`);
        history.push(`/content/register/${record.id}`);
      },
    };
  };

  /**
   * page 넘김
   */
  const handleChangePagination = (pageNumber, pageSize) => {
    const offset = (pageNumber - 1) * pageSize;
    setCurrentPageNumber(pageNumber);
    setOffset(offset);
    setPageSize(pageSize);
  };

  return (
    <>
      <ContentHeaderComponent title="콘텐츠 조회/수정" />
      <div className="product-register-wrap">
        {/*콘텐츠 검색*/}
        <div className="product-search-box-wrap">
          <Form.Item
            label="검색어"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Row align="middle" wrap={false} style={{ marginBottom: 17 }}>
              <Col span={2}>
                <div className="content-search-wrap">콘텐츠명</div>
              </Col>
              <Col span={16}>
                <Input
                  name="content_title"
                  value={searchOptions.content_title}
                  onChange={(e) =>
                    handleSearchOptionChange(e.target.name, e.target.value)
                  }
                />
              </Col>
            </Row>
            <Row align="middle" wrap={false}>
              <Col span={2}>
                <div className="content-search-wrap">해시태그</div>
              </Col>
              <Col span={16}>
                <Input
                  name="hashtag"
                  value={searchOptions.hashtag}
                  onChange={(e) =>
                    handleSearchOptionChange(e.target.name, e.target.value)
                  }
                />
              </Col>
            </Row>
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="노출 여부"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Radio.Group
              className="content-search-radio-group-wrap"
              options={exposureItemList}
              name="is_exposure"
              value={searchOptions.is_exposure}
              onChange={(e) =>
                handleSearchOptionChange(e.target.name, e.target.value)
              }
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className="center-label"
            label="노출 장소"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Checkbox.Group
              className="content-search-check-box-wrap"
              options={exposurePlaceItemList}
              name="exposure_place"
              value={searchOptions.exposure_place}
              onChange={(e) => handleSearchOptionChange("exposure_place", e)}
            />
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Form.Item
            className={
              searchOptions.category &&
              (searchOptions.category.includes("age") ||
                searchOptions.category.includes("symptom"))
                ? ""
                : "center-label"
            }
            label="카테고리"
            labelAlign="left"
            colon={false}
            labelCol={{ span: 3 }}
            wrapperCol={{ span: 21 }}
          >
            <Checkbox.Group
              className="content-search-check-box-wrap"
              options={categoryItemList}
              name="category"
              value={searchOptions.category}
              onChange={(e) => handleSearchOptionChange("category", e)}
            />
            {searchOptions.category &&
              searchOptions.category.includes("age") && (
                <>
                  <Divider className="product-register-form-input-divider" />
                  <div className="content-search-wrap">연령별</div>
                  <Row style={{ rowGap: 8 }}>
                    {targetAgeItems.map((targetAge, idx) => (
                      <Col span={6}>
                        <Checkbox
                          key={`targetAge_${idx}`}
                          name="sub_category"
                          value={targetAge.label}
                          onChange={(e) =>
                            handleSearchOptionChange(
                              e.target.name,
                              e.target.value,
                              e.target.checked,
                            )
                          }
                          checked={
                            searchOptions.sub_category &&
                            searchOptions.sub_category.includes(targetAge.label)
                          }
                        >
                          {targetAge.label}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
            {searchOptions.category &&
              searchOptions.category.includes("symptom") && (
                <>
                  <Divider className="product-register-form-input-divider" />
                  <div className="content-search-wrap">증상별</div>
                  <Row style={{ rowGap: 8 }}>
                    {symptomList.map((effect, idx) => (
                      <Col span={6}>
                        <Checkbox
                          key={`effect_${idx}`}
                          id={effect.effect_id}
                          name="sub_category"
                          value={effect.effect_id}
                          onChange={(e) =>
                            handleSearchOptionChange(
                              e.target.name,
                              e.target.value,
                              e.target.checked,
                            )
                          }
                          checked={
                            searchOptions.sub_category &&
                            searchOptions.sub_category.includes(
                              effect.effect_id,
                            )
                          }
                        >
                          {effect.effect_name}
                        </Checkbox>
                      </Col>
                    ))}
                  </Row>
                </>
              )}
          </Form.Item>
          <Divider className="product-register-form-input-divider" />
          <Row className="review-search-button-wrap" justify="center">
            <Button
              className="review-search-button search"
              onClick={handleSearch}
            >
              검색
            </Button>
            <Button
              className="review-search-button initial"
              onClick={handleInitialBtnClick}
            >
              초기화
            </Button>
          </Row>
        </div>

        {/*콘텐츠 목록*/}
        <Row
          className="product-register-border-box"
          justify={"space-between"}
          wrap={false}
          style={{ marginTop: 20 }}
        >
          <div>
            <span className="product-register-box-title">
              콘텐츠 목록 (총{" "}
              <span
                className="product-register-box-subtitle"
                style={{ marginLeft: 0 }}
              >
                {totalSize}
              </span>
              개)
            </span>
            <span className="product-list-subtitle">
              {orderPair[orderType]}
            </span>
          </div>
          {/*<Button className="order-excel-download-btn" icon={<img style={{height: 14.2, width: 14.5, marginRight: 5}} src={`${process.env.REACT_APP_HOST}/assets/images/salesManage/microsoftexcel.png`} />} onClick={handleExcelDownloadClick}>엑셀다운</Button>*/}
        </Row>
        <div
          className="product-register-border-box"
          wrap={false}
          style={{
            borderTop: 0,
            padding: "20px 25px 40px",
            height: "fit-content",
          }}
        >
          <Table
            className="content-table-wrap"
            columns={columns}
            dataSource={contentList}
            loading={isLoading}
            tableLayout={"auto"}
            bordered
            size="middle"
            rowKey="id"
            rowClassName="coupon-table-row"
            scroll={{ x: "max-content" }}
            onChange={tableOnChange}
            onRow={handleRowEvent}
            pagination={false}
          />

          <div style={{ textAlign: "right" }}>
            <Pagination
              showQuickJumper
              showSizeChanger
              total={totalSize}
              pageSize={pageSize}
              onChange={handleChangePagination}
              style={{ marginTop: 20 }}
              current={currentPageNumber}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ContentListComponent;
